<template>
  <div class="my-3">
    <b-card bg-variant="light" class="my-3">
      <b-row>
        <b-col>
          <h4 class="text-secondary">{{ $t("globals.replace") }}:</h4>
        </b-col>
        <!-- Actions for 'created' status -->
        <b-col v-if="service.status == 'created'">
          <b-btn
            v-if="
              getUserBrandPermissions.order_service_edit_request_replace
              && this.edit_service == false
            "
            class="float-right mx-1"
            variant="success"
            size="sm"
            @click="requestService('iceu')"
            :disabled="!enableRequest"
          >
            {{ $t("globals.request") }}
          </b-btn>
          <b-btn
            v-if="
              getUserBrandPermissions.order_service_edit_request_replace
              && this.edit_service == false
            "
            class="float-right mx-1"
            variant="success"
            size="sm"
            @click="requestService('fieldtracker')"
            :disabled="!enableRequest"
          >
            {{ $t("globals.request_fieldtracker") }}
          </b-btn>
          <b-btn
            v-if="
              !edit_service &&
                getUserBrandPermissions.order_service_edit_request_replace
            "
            class="float-right mx-1"
            variant="info"
            size="sm"
            @click="edit_service = true"
          >
            {{ $t("globals.edit") }}
          </b-btn>
          <b-btn
            v-if="edit_service"
            class="float-right mx-1"
            variant="success"
            size="sm"
            @click="saveEdit"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            v-if="edit_service"
            class="float-right mx-1"
            variant="info"
            size="sm"
            @click="cancelEdit"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="12" md="6">
          <b-row>
            <b-col cols="4">
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.reason") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
                :placeholder="service.reason"
                size="sm"
                disabled
              />
            </b-col>
            <b-col v-if="service.reason == 'other'">
              <div v-b-tooltip.hover :title="service.reason_other">
                <b-form-input
                  :placeholder="service.reason_other"
                  size="sm"
                  disabled
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.contact_information") }}:*
              </h6>
            </b-col>
            <b-col>
              <b-form-textarea
                v-model="service.contact_info"
                rows="5"
                :disabled="!edit_service"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                class="m-2"
                v-model="service.warranty"
                :value="true"
                :unchecked-value="false"
                :disabled="!edit_service"
              >
                {{ $t("globals.warranty") }}:
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <div class="px-2 float-right">
            <blockquote class="trello-card">
              <a :href="service.trello_card_url"></a>
            </blockquote>
          </div>
        </b-col>
      </b-row>
      <!-- Service Devices Table -->
      <ulu-service-devices
        :service="service"
        :refresh="refresh"
      />
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-service-devices": () =>
      import("@/components/services/service/ServiceDevices"),
  },
  props: {
    refresh: Function,
    service: {
      type: Object,
      default: () => ({
        id: 0,
        status: "created",
        service_type: "replacement",
        trello_card_url: "",
        contact_info: "",
        warranty: false
      })
    }
  },
  data() {
    return {
      edit_service: false,    
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    cancelEdit() {
      this.edit_service = false;
      this.refresh();
    },
    saveEdit() {
      const data = {
        query: `
          mutation {
            res: ServiceEdit (
              service_id: ${this.service.id},
              contact_info: "${this.service.contact_info}",
              warranty: ${this.service.warranty}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.edit_service = false;
        this.refresh();
      });
    },
    requestService(installation_company) {
      const data = {
        query: `
          mutation {
            res: ServiceReplaceRequest (
              service_id: ${this.service.id},
              install_company: "${installation_company}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.$router.go();
      });
    },
    loadTrello() {
      let trello_script = document.createElement("script");
      trello_script.setAttribute("src", "https://p.trellocdn.com/embed.min.js");
      document.head.appendChild(trello_script);
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    enableRequest() {
      const any_uncompleted_devices = this.service.service_devices.filter(d => 
        d.imei == null ||
        d.imei == "" ||
        d.license_plate == null ||
        d.license_plate == ""
      ).length > 0

      return (
        this.service.service_devices.length > 0 &&
        !any_uncompleted_devices &&
        this.service.contact_info != null &&
        this.service.contact_info.length > 3
      );
    }
  },
  mounted() {
    this.loadTrello();
  },
  watch: {
    $route() {
      this.loadTrello();
    }
  }
};
</script>
